import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import HelpIcon from '@mui/icons-material/Help';
import howToPlay from '../../static/images/howToPlay.webp'
import { green } from '@mui/material/colors';
import { QUESTION_TYPES } from '../../constants/appConstants';

export default function HowToPlay({settings, questionType}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

const defaultHowToPlay = () => {
    return <><img src={howToPlay} alt={`How to play ${questionType}`} width={300} height={300}></img>
          <DialogContentText id="alert-dialog-description">
            Steps
            <ul>
              <li>Step1: Do This</li>
              <li>Step2: Do that</li>
              <li>Step3: Do that again </li>
            </ul>
          </DialogContentText>
          </>
  }


  const getStyle = (color) => {
    return {backgroundColor: color, color: 'white', padding: '2px', borderRadius: '5px'}
  }

  const wordleHowToPlay = () => {
    return <>
    <ul>
      <li>
      Each guess must be a valid four/five/six letter word.
      </li>
      <li>
      The color of a tile will change to show you how close your guess was.
      </li>
      <li>
      If the tile turns <span style={getStyle('green')}> green </span> , the letter is in the word, but it is not in the correct spot.
      </li>
      <li>
      If the tile turns <span style={getStyle('goldenrod')}> yellow </span>, the letter is in the word, but it is not in the correct spot.
      </li>
      <li>
      If the tile turns <span style={getStyle('gray')}> grey </span>, the letter is not in the word.
      </li>
    </ul>
    </>
  }

  return (
    <React.Fragment>
      <IconButton aria-label="hint" onClick={handleClickOpen}>
        <HelpIcon/>
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          How to play {questionType}?
        </DialogTitle>
        <DialogContent>
        {questionType === QUESTION_TYPES.WORDLE ? wordleHowToPlay() : defaultHowToPlay()}
          

        </DialogContent>
        <hr/>
        <DialogActions>
          <Button onClick={handleClose} variant={'contained'}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
